import React from 'react'

const StrapiProducts = () => {
  return (
    <div>StrapiProducts</div>
  )
}

export default StrapiProducts